import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RegionProvider } from "@/context/RegionContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import UsLandingPage from "@/pages/UsLandingPage";
import UkLandingPage from "@/pages/UkLandingPage";
import AuthPage from "@/pages/AuthPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import GeneratorPage from "@/pages/GeneratorPage";
import SavedIdeasPage from "@/pages/SavedIdeasPage";
import PricingPage from "@/pages/PricingPage";
import UsPricingPage from "@/pages/UsPricingPage";
import UkPricingPage from "@/pages/UkPricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AffiliateInterestPage from "@/pages/AffiliateInterestPage";
import AffiliateDashboard from "@/pages/AffiliateDashboard";
import SubscriptionPage from "@/pages/SubscriptionPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminCreatorPage from "@/pages/AdminCreatorPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import SupportPage from "@/pages/SupportPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePage from "@/pages/CookiePage";
import ProfilePage from "@/pages/ProfilePage";
import DashboardPage from "@/pages/DashboardPage";
import CreatorDashboardPage from "@/pages/CreatorDashboardPage";
import FolderDetailPage from "@/pages/FolderDetailPage";
import FAQPage from "@/pages/FAQPage";
import AboutPage from "@/pages/AboutPage";
import ViolationWizardPage from "@/pages/ViolationWizardPage";
import PublicViolationWizardPage from "@/pages/PublicViolationWizardPage";
import IncomeCalculatorPage from "@/pages/IncomeCalculatorPage";
import VideosPage from "@/pages/VideosPage";
import HelpSupportPage from "@/pages/HelpSupportPage";
import CookieBanner from "@/components/CookieBanner";
import RouteTracker from "@/components/RouteTracker";
import { initConsent } from "@/lib/consent";
import { initPixel } from "@/lib/metaPixel";

function App() {
  useEffect(() => { initConsent(); initPixel(); }, []);
  return (
    <div className="min-h-screen bg-background">
      <AuthProvider>
        <RegionProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/us" element={<UsLandingPage />} />
            <Route path="/uk" element={<UkLandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/auth-callback" element={<AuthCallbackPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/us/pricing" element={<UsPricingPage />} />
            <Route path="/uk/pricing" element={<UkPricingPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/forgot-password" element={<ResetPasswordPage />} />
            <Route path="/affiliate-interest" element={<AffiliateInterestPage />} />
            <Route path="/backendcontrol" element={<AdminLoginPage />} />
            <Route path="/backendcontrol/dashboard" element={<AdminDashboardPage />} />
            <Route path="/backendcontrol/creator" element={<AdminCreatorPage />} />
            <Route path="/verify-email" element={<ProtectedRoute><VerifyEmailPage /></ProtectedRoute>} />
            <Route path="/affiliate-dashboard" element={<AffiliateDashboard />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/free-violation-appeal" element={<PublicViolationWizardPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookies" element={<CookiePage />} />
            <Route 
              path="/subscription" 
              element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} 
            />
            <Route 
              path="/profile" 
              element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} 
            />
            <Route 
              path="/dashboard" 
              element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} 
            />
            <Route 
              path="/creator-dashboard" 
              element={<ProtectedRoute><CreatorDashboardPage /></ProtectedRoute>} 
            />
            <Route 
              path="/violation-wizard" 
              element={<ProtectedRoute><ViolationWizardPage /></ProtectedRoute>} 
            />
            <Route 
              path="/income-calculator" 
              element={<ProtectedRoute><IncomeCalculatorPage /></ProtectedRoute>} 
            />
            <Route 
              path="/videos" 
              element={<ProtectedRoute><VideosPage /></ProtectedRoute>} 
            />
            <Route 
              path="/help" 
              element={<ProtectedRoute><HelpSupportPage /></ProtectedRoute>} 
            />
            <Route 
              path="/dashboard/folders/:id" 
              element={<ProtectedRoute><FolderDetailPage /></ProtectedRoute>} 
            />
            <Route 
              path="/payment-success" 
              element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} 
            />
            <Route path="/generator" element={<GeneratorPage />} />
            <Route 
              path="/saved" 
              element={<ProtectedRoute><SavedIdeasPage /></ProtectedRoute>} 
            />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        </RegionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
